<template>
  <div class="footer">
    <p class="copyright">© 2019-{{ year }} 车库Lab</p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style scoped>
.footer {
  border-top: 1px solid #dcdfe6;
  padding-left: 2.5em;
}
.copyright {
  font-size: .85rem;
  color: #4a4a4a;
  padding-top: 1em;
}
</style>